module.exports = __webpack_public_path__ + "img/missing calls.282b08bd.png";